import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { EGIS_SERVICE_CALLER } from '../../../../../constants';
import { SlutopgoerelseService } from '../../../../../api/services/slutopgoerelse.service';
import { SlutopgoerelseDraftRequestDto } from '../../../../../api/models/OK/Egis/Service/Models/DTO/slutopgoerelse-draft-request-dto';
import { SlutopgoerelseDraftDto } from '../../../../../api/models/OK/Egis/Service/Models/DTO/slutopgoerelse-draft-dto';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ErrorHandlerService } from '../../../../../services/error-handler.service';
import { KundesegmentEnum } from '../../../../../api/models/OK/Egis/Service/Models/Entities/Enums/kundesegment-enum';
import { SlutopgoerelseDraftLinieDto } from '../../../../../api/models/OK/Egis/Service/Models/DTO/slutopgoerelse-draft-linie-dto';
import { AmountDto } from '../../../../../api/models/OK/Egis/Service/Models/DTO/amount-dto';

@Component({
    selector: 'app-slutopgoerelse-draft',
    templateUrl: './slutopgoerelse-draft.component.html',
    styleUrls: ['./slutopgoerelse-draft.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SlutopgoerelseDraftComponent implements OnInit, OnDestroy, OnChanges {
  @Input() form: UntypedFormGroup;
  @Input() serviceaftaleId: number;
  @Input() kundesegment: KundesegmentEnum;
  @Input() endDate: Date;

  slutopgoerelseDraft: SlutopgoerelseDraftDto;
  fetchingSlutopgoerelseDraft: boolean;
  unsubscribe$ = new Subject<void>();

  constructor(private slutopgoerelseService: SlutopgoerelseService, private errorHandler: ErrorHandlerService) {}

  ngOnInit() {
    this.form.valueChanges.pipe(takeUntil(this.unsubscribe$), debounceTime(300)).subscribe(() => {
      this.updateDraft();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.updateDraft();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  getPriceStringForLine(line: SlutopgoerelseDraftLinieDto) {
    return line.antal * this.getPrice(line.stkAmount);
  }

  getPrice(amount: AmountDto) {
    return this.kundesegment === KundesegmentEnum.Privat ? amount.withMoms : amount.withoutMoms;
  }

  updateDraft() {
    if (!this.form.controls.createSlutopgoerelse.value || this.endDate == null) {
      this.slutopgoerelseDraft = null;
      return;
    }

    const request: SlutopgoerelseDraftRequestDto = {
      serviceaftaleId: this.serviceaftaleId,
      payUntilEndOfPeriod: this.form.controls.payUntilEndOfPeriod.value,
      correctForFrieTilkald: this.form.controls.tilvalgCorrection.value,
      manuelCorrectionAmount: this.form.controls.addManuelCorrection.value ? this.form.controls.manuelCorrection.value : null,
      endDate: this.endDate.toOkDateString(),
    };

    this.fetchingSlutopgoerelseDraft = true;

    this.slutopgoerelseService
      .getSlutopgoerelseDraft({ caller: EGIS_SERVICE_CALLER, body: request })
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (response) => {
          this.fetchingSlutopgoerelseDraft = false;
          this.slutopgoerelseDraft = response;
        },
        (error) => {
          this.fetchingSlutopgoerelseDraft = false;
          this.errorHandler.HandleError(error);
        }
      );
  }
}
